// extracted by mini-css-extract-plugin
export default {"photo":"FeedPhotosItem_photo__n9xPN","visualizations":"FeedPhotosItem_visualizations__ua77I"};